// extracted by mini-css-extract-plugin
export default {"container":"App_container__Rt8T2","title":"App_title__YS7Xx","loading":"App_loading__Z10nZ","girar":"App_girar__6KsF7"};